<template>
  <router-view/>
</template>

<script>
// import HelloWorld from './components/HelloWorld';
import Vue from "vue";

export default {
  name: 'App',

  data() {
    return {
      eventHub: new Vue()
    };
  },
  provide() {
    return {
      eventHub: this.eventHub
    };
  }
};
</script>
